export const RESET_STORE = 'RESET_STORE';

export const resetStore = () => ({
  type: RESET_STORE,
});

export const resetStoreExceptUserAndCategories = () => ({
  type: 'RESET_STORE_EXCEPT_USER_CATEGORIES'
});